var React = require('react');

function DifficultyLevelBluePill (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_2","data-name":"Layer 2"},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("g",{"id":"Artwork_12","data-name":"Artwork 12"},[React.createElement("rect",{"fill":"#E7993B","width":"132","height":"67.35","rx":"32.31","key":0}),React.createElement("rect",{"fill":"#00aeef","stroke":"#fff","strokeMiterlimit":"10","strokeWidth":"2","x":"43.06","y":"11.02","width":"45.56","height":"45.56","key":1})]))));
}

DifficultyLevelBluePill.defaultProps = {"viewBox":"0 0 132 67.35"};

module.exports = DifficultyLevelBluePill;

DifficultyLevelBluePill.default = DifficultyLevelBluePill;
